export * from './get-access.component';